/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const teamPartnershipDtoSchema = z.object({
  name: z.optional(z.string()),
  metrics: z.optional(z.string()),
  about: z.optional(z.string()),
  strategicRelevance: z.optional(z.array(z.string())),
  website: z.optional(z.string()),
});
